import { TextField } from '@mui/material';

interface AuthorityFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function AuthorityField({
  value,
  error,
  setValue,
}: AuthorityFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Authority URL'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default AuthorityField;

